import { createApi, fakeBaseQuery } from "@reduxjs/toolkit/query/react";
import { prewarmHtsAssist, type PrewarmHtsAssistRequest } from "./prewarm";

export const HTS_ASSIST_PREWARM_CACHE_SECONDS = 5 * 60;

export const getHtsAssistPrewarmCacheKey = (
  request: PrewarmHtsAssistRequest
): string => {
  const supportContext = request.supportContext;
  return supportContext
    ? `${supportContext.productType}:${supportContext.bookingId}`
    : "generic";
};

type PrewarmError = {
  message: string;
};

export const htsAssistPrewarmApi = createApi({
  reducerPath: "htsAssistPrewarmApi",
  baseQuery: fakeBaseQuery<PrewarmError>(),
  refetchOnFocus: false,
  refetchOnReconnect: false,
  endpoints: (builder) => ({
    prewarm: builder.query<true, PrewarmHtsAssistRequest>({
      keepUnusedDataFor: HTS_ASSIST_PREWARM_CACHE_SECONDS,
      serializeQueryArgs: ({ queryArgs }) =>
        getHtsAssistPrewarmCacheKey(queryArgs),
      queryFn: async (request) => {
        try {
          await prewarmHtsAssist(request);
          return { data: true };
        } catch (error) {
          return {
            error: {
              message:
                error instanceof Error ? error.message : "Prewarm failed",
            },
          };
        }
      },
    }),
  }),
});
